import LtrLayout from "app-layouts/ltr-layouts/Layout";
import { assignmentDetailString, assignmentResultString, assignmentString, commonStrigns, headersString, onlineExamDetailString, onlineExamResultString, onlineExamString } from "res/strings";

export const HomePageConfig = {
  layout: LtrLayout,
  settings: {
    layout: {
      config: {
        headerTitle: {
          display: false,
        },
      },
    },
  },
};


export const LoginPageConfig = {
  layout: LtrLayout,
  settings: {
    layout: {
      config: {
        header: {
          display: false,
        },
        footer: {
          display: false,
        },
      },
    },
  },
};

export const AttendancePageConfig = {
  layout: LtrLayout,
  title: "Attendance",
  settings: {
    layout: {
      config: {},
    },
  },
};

export const IeltsPageConfig = {
  layout: LtrLayout,
  title: "Ielts",
  settings: {
    layout: {
      config: {},
    },
  },
};

export const MessagesPageConfig = {
  layout: LtrLayout,
  title: "Messages",
  settings: {
    layout: {
      config: {},
    },
  },
};

export const RoomPageConfig = {
  layout: LtrLayout,
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
      },
    },
  },
};

export const ClassSchedulePageConfig = {
  layout: LtrLayout,
  title: "class schedule",
  settings: {
    layout: {
      config: {},
    },
  },
};

export const ExamsPageConfig = {
  layout: LtrLayout,
  title: "Exams",
  settings: {
    layout: {
      config: {},
    },
  },
};

export const ContentPageConfig = {
  layout: LtrLayout,
  title: "Content",
  settings: {
    layout: {
      config: {},
    },
  },
};

export const HomeworkPageConfig = {
  layout: LtrLayout,
  title: "Homework",
  settings: {
    layout: {
      config: {},
    },
  },
};

export const GalleryPageConfig = {
  layout: LtrLayout,
  title: "Gallery",
  settings: {
    layout: {
      config: {},
    },
  },
};

export const NewsPageConfig = {
  layout: LtrLayout,
  title: "News",
  settings: {
    layout: {
      config: {},
    },
  },
};
export const OnlineExamPage = {
  layout: LtrLayout,
  title: onlineExamString.header,
  settings: {
    layout: {
      config: {
        disableBack: true,
        footer: {
          display: false,
        },
      },
    },
  },
};
export const AssignmentPage = {
  layout: LtrLayout,
  title: assignmentString.header,
  settings: {
    layout: {
      config: {
        disableBack: true,
        footer: {
          display: false,
        },
      },
    },
  },
};

export const AssignmentArchivePage = {
  layout: LtrLayout,
  title: "آرشیو نتایج تکلیف",
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
      },
    },
  },
};
export const OnlineExamArchivePage = {
  layout: LtrLayout,
  title: "آرشیو نتایج آزمون",
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
      },
    },
  },
};


export const OnlineExamDetailPage = {
  layout: LtrLayout,
  title: onlineExamDetailString.header,
  settings: {
    layout: {
      config: {
        showReport: true,
        disableBack: true,
        footer: {
          display: false,
        },
      },
    },
  },
};

export const OnlineExamAnswerDetailPage = {
  layout: LtrLayout,
  title: onlineExamDetailString.header,
  settings: {
    layout: {
      config: {
        showReport: true,
        footer: {
          display: false,
        },
      },
    },
  },
};

export const OnlineExamResultPage = {
  layout: LtrLayout,
  title: onlineExamResultString.header,
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
      },
    },
  },
};
export const AssignmentDetailPage = {
  layout: LtrLayout,
  title: assignmentDetailString.header,
  settings: {
    layout: {
      config: {
        showReport: true,
        disableBack: true,
        footer: {
          display: false,
        },
      },
    },
  },
};

export const AssignmentAnswerDetailPage = {
  layout: LtrLayout,
  title: assignmentDetailString.header,
  settings: {
    layout: {
      config: {
        showReport: true,
        footer: {
          display: false,
        },
      },
    },
  },
};

export const AssignmentResultPage = {
  layout: LtrLayout,
  title: assignmentResultString.header,
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
      },
    },
  },
};

export const SingleNewsPageConfig = {
  layout: LtrLayout,
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
      },
    },
  },
};

export const SingleGalleryPageConfig = {
  layout: LtrLayout,
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
      },
    },
  },
};

export const ProfilePageConfig = {
  layout: LtrLayout,
  title: "Profile",
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
      },
    },
  },
};
